import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Search } from "lucide-react";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { ChatbotWidget } from "../components/ChatbotWidget";

export default function NotFound() {
    const navigate = useNavigate();
    const [q, setQ] = useState("");
    const submit = (e) => {
        e.preventDefault();
        if (!q.trim()) return;
        navigate(`/search?q=${encodeURIComponent(q.trim())}`);
    };
    return (
        <div className="min-h-screen bg-ivory" data-testid="not-found-page">
            <Header />
            <main className="max-w-3xl mx-auto px-6 py-20 text-center">
                <span className="label-eyebrow">Lost in the boutique</span>
                <h1 className="mt-4 font-display text-5xl sm:text-6xl text-inkDark tracking-tight">404</h1>
                <p className="mt-3 text-inkMuted">
                    We couldn&rsquo;t find the page you were looking for. Perhaps it moved to a different drape.
                </p>
                <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
                    <Link to="/" className="btn-pill" data-testid="not-found-home-link">Back home</Link>
                    <Link to="/category/sarees" className="btn-ghost text-sm">Shop sarees</Link>
                </div>
                <form onSubmit={submit} className="mt-10 max-w-md mx-auto" data-testid="not-found-search-form">
                    <div className="flex items-center gap-2 rounded-full bg-ivory border border-inkDark/10 px-4 py-2.5 focus-within:border-skyblueDeep">
                        <Search size={16} className="text-inkMuted" />
                        <input
                            value={q}
                            onChange={(e) => setQ(e.target.value)}
                            placeholder="Search sarees, kurtis, lehengas…"
                            className="flex-1 bg-transparent outline-none text-inkDark placeholder:text-inkMuted/70 text-sm"
                            data-testid="not-found-search-input"
                        />
                        <button type="submit" className="text-sm text-skyblueDeep hover:underline" data-testid="not-found-search-submit">
                            Search
                        </button>
                    </div>
                </form>
            </main>
            <Footer />
            <ChatbotWidget />
        </div>
    );
}
